import { useCallback, useState } from 'react';

const STORAGE_KEY = 'flowgate.autoSaveEnabled';

/**
 * Browser-persisted preference for whether edits auto-save (debounced) or wait for an explicit
 * "Save now". Defaults to ON, the local-first save is cheap, so auto-save is the sensible default;
 * users who want deliberate, version-snapshotted saves can turn it off. Stored per-browser in
 * localStorage (not per-flow) so the choice sticks across flows and sessions.
 */
export function useAutoSavePreference() {
  const [enabled, setEnabledState] = useState(() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) !== 'false';
    } catch {
      return true;
    }
  });

  const setEnabled = useCallback((value) => {
    setEnabledState(value);
    try {
      window.localStorage.setItem(STORAGE_KEY, value ? 'true' : 'false');
    } catch {
      // Ignore, a blocked localStorage just means the preference won't persist across reloads.
    }
  }, []);

  return [enabled, setEnabled];
}
